export class Description {
    mainDescription: string;
    productDescription: string;
    highlights: string;
    whatIsInTheBox: string;

    constructor(
        mainDescription: string = "",
        productDescription: string = "",
        highlights: string = "",
        whatIsInTheBox: string = "",
    ) {
        this.mainDescription = mainDescription;
        this.productDescription = productDescription;
        this.highlights = highlights;
        this.whatIsInTheBox = whatIsInTheBox;
    }
}